import { Component, Input, booleanAttribute, inject } from '@angular/core';
import { Layer } from '@app/modules/cop/store/cop/models';
import { Dataset, Document } from '@app/modules/core/store/models';
import { Store } from '@ngrx/store';
import * as fromCop from 'src/app/modules/cop/store/cop';
import { HorizonRatingsFacade } from '@app/modules/cop/store/horizon-ratings';

@Component({
    selector: 'topo-ratings-content-header',
    templateUrl: './ratings-content-header.component.html',
    styleUrls: ['./ratings-content-header.component.scss'],
    standalone: false
})
export class RatingsContentHeaderComponent {
  @Input() layer: Layer;
  @Input() dataset: Dataset;
  @Input() document: Document;
  @Input() showActions: boolean = true;
  @Input({ transform: booleanAttribute }) loadRatingsDocuments: boolean;
  @Input({ transform: booleanAttribute }) hideRatingsExpand: boolean;

  private store = inject(Store);
  private facade = inject(HorizonRatingsFacade);

  zoomToDocument() {
    this.store.dispatch(
      fromCop.zoomToDocument({
        layer: this.layer,
        dataset: this.dataset,
        document: this.document
      })
    );
  }

  showRatingsDetails(event: MouseEvent): void {
    event.stopPropagation();
    this.facade.showExpandedView(this.layer.datasetUId, this.document, this.loadRatingsDocuments);
  }
}
